import React, { useState, useRef, useEffect } from 'react'
import { displayFile } from '../../../utils';
import Button from '../../templates/Button';
import InputField from '../../templates/InputField'
import toast from '../../templates/ToastMessage'
import { useDispatch, useSelector } from 'react-redux'
import { addAdmin } from '../../../redux_store/auth/auth_thunk';
import { FAIL, LOADING, SUCCESS } from '../../../redux_store/actionTypes';
import LoadingModal from '../../templates/modals/LoadingModal';
import { useNavigate } from 'react-router-dom'

const ManageAdminsPage = () => {
  const { message, status } = useSelector((state)=> state.auth);
  const [details, setDetails] = useState({});
  // const [state, setState] = useState('create');
  const imageRef = useRef(null);
  const profilePicRef = useRef(null);
  const dispatch = useDispatch();
  const navigator = useNavigate();

  useEffect(()=>{
    displayFile(details.profile_pic, profilePicRef.current);
    // eslint-disable-next-line
  } ,[]);
  
  useEffect(()=>{
    if(status === FAIL){
      toast({message, status});
    }else if(status === SUCCESS){
      toast({message, status});
      navigator('/admins');
    }
    // eslint-disable-next-line
  }, [status]);

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setDetails({...details, [name]:value});
  }

  const handleImageSelect = () => {
    const image = imageRef.current;
    image.click();
    image.addEventListener('change', (e)=>{
      setDetails({...details, profile_pic :image.files[0]});
      displayFile(image.files[0], profilePicRef.current);
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if(!details.profile_pic){
      toast({message: 'Kindly select an image', status: 'fail'});
    }else{
      const phone_number = details.phone_number;
      let formattedPhoneNumber = '';
      if(phone_number.length === 10){
        formattedPhoneNumber = '233' + phone_number.slice(1);
      }else{
        formattedPhoneNumber = phone_number;
      }
      dispatch(addAdmin({
        ...details, phone_number: formattedPhoneNumber
      }));
    }
  }

  return (
    <form onSubmit={handleFormSubmit} className='grid gap-y-5 gap-x-8 py-10 px-16 grid-cols-2 bg-white shadow-md rounded'>
      {status === LOADING && <LoadingModal message={'Please wait...'} />}
      <input type={'file'} ref={imageRef} name="profile_pic" hidden />
      <div className='border flex flex-col border-gray-400 shadow-md h-48 w-1/3 col-span-2'>
        <div ref={profilePicRef} className="w-full h-full"></div>
        <button type='button' onClick={handleImageSelect} className='w-full z-10 bg-gray-200 py-1'>select image</button>
      </div>

      <div>
        <p className='text-gray-500 font-medium text-sm'>Firstname</p>
        <InputField 
          type={'text'}
          name="firstname"
          isRequired={true}
          onChange={handleInputChange}
          value={details.firstname}
          placeholder="Enter firstname" 
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Lastname</p>
        <InputField 
          type={'text'}
          name="lastname"
          isRequired={true}
          onChange={handleInputChange}
          value={details.lastname}
          placeholder="Enter lastname" 
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Email Address</p>
        <InputField 
          type={'email'}
          name="email"
          isRequired={true}
          onChange={handleInputChange}
          value={details.email}
          placeholder="Enter email" 
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Phone Number</p>
        <InputField 
          type={'text'}
          name="phone_number"
          isRequired={true}
          onChange={handleInputChange}
          value={details.phone_number}
          placeholder="Enter phone number" 
        />
      </div>
      <div className='col-span-2'>
        <Button
          type="submit"
          label={'Submit'}
          width="w-full"
          bgColor={'wayrideBgColor'}
        />
      </div>
    </form>
  )
}

export default ManageAdminsPage